import { Component, Inject } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Exercise } from '@app/shared/exercise/models/exercise.model'

@Component({
    selector: 'aio-print-dialog',
    templateUrl: './print.component.html',
    styleUrls: ['./print.component.sass'],
    standalone: false
})
export class PrintDialogComponent {
  public columns: UntypedFormGroup
  public typologies: UntypedFormGroup

  constructor(
    public dialogRef: MatDialogRef<PrintDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public exercise: Exercise,
    private formBuilder: UntypedFormBuilder
  ) {
    if (exercise) {
      this.columns = this.formBuilder.group({})
      this.typologies = this.formBuilder.group({})
      const [primary, secondary] = exercise.categories
      primary.forEach((p) => {
        this.columns.addControl(p, this.formBuilder.control(true))
      })

      // Add custom control checkbox for expeditions column
      this.columns.addControl('EXP', this.formBuilder.control(true))

      secondary.forEach((s) => {
        this.typologies.addControl(s, this.formBuilder.control(true))
      })
    }
  }

  print() {
    // Get values of the form groups. Only keep the label as value where the value is true.
    const columnValues = Object.entries(this.columns.value)
      .filter((e) => !e[1])
      .map((e) => e[0])
    const typoValues = Object.entries(this.typologies.value)
      .filter((e) => !e[1])
      .map((e) => e[0])
    const elementsToIgnore: string[] = [...columnValues, ...typoValues]
    this.dialogRef.close(elementsToIgnore)
  }
}
